import { TComputedPropMapper } from '../../../types/computed-props-mapper';

export const isFromSeller: TComputedPropMapper<boolean> = ({ offer: { newbuilding } }) =>
  Boolean(newbuilding && newbuilding.isFromSeller);
